module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.2f3e9f80.ttf";